import React from "react";
import { EnseigneMainProfile } from "./main-profiles/enseigne";
import { CandidatMainProfile } from "./main-profiles/candidat";
import { VilleMainProfile } from "./main-profiles/ville";

interface Profile {
  id: number;
  type: "candidat" | "enseigne" | "ville" | "location";
  name: string;
  avatar_url?: string;
  logo_url?: string;
  [key: string]: any;
}

interface MainProfileCardProps {
  profile: Profile;
  secteurs?: any[];
}

export function MainProfileCard({ profile, secteurs }: MainProfileCardProps) {
  if (profile.type === "enseigne") {
    return <EnseigneMainProfile profile={profile} secteurs={secteurs} />;
  } else if (profile.type === "candidat") {
    return <CandidatMainProfile profile={profile} secteurs={secteurs} />;
  } else if (profile.type === "ville") {
    return <VilleMainProfile profile={profile} secteurs={secteurs} />;
  }

  // Fallback for unsupported profile types
  return (
    <div className="h-full flex items-center justify-center p-6">
      <div className="text-slate-500">Type de profil non supporté</div>
    </div>
  );
}
